import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Select2Data, Select2Option } from 'ng-select2-component';
import { RepresentantesPartesService } from './representantes.service';
import { UsuarioService } from '../usuarios/usuarios.service';
import { Representante } from './representante.model';
import { Usuario } from '../usuarios/usuarios.model';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { PartesService } from './partes.service';
import { Parte } from './partes.model';
import { AuthenticationService } from '../core/service/auth.service';
import { CasosService } from '../casos/casos.service';
import { ChangeDetectorRef } from '@angular/core';

//Parto del modelo de Institución para el Representante
interface RepresentantoConDetalles extends Representante {
  nombre?: string;
  apellidos?: string;
  enviar_email_subida_archivo?: boolean;
  usuario?: {
    validado?: boolean;
    // Otras propiedades de usuario
  };
}

@Component({
  selector: 'app-representantes',
  templateUrl: './representantes.component.html',
  styleUrls: ['./representantes.component.scss']
})
export class RepresentantesComponent implements OnInit {

  @Input() parteId: string | null = null;
  @Output() changePartesView = new EventEmitter<{ view: string }>();
  @Output() refreshCase = new EventEmitter<void>();

  usuarios: Select2Data = [];
  usuariosList: Usuario[] = [];
  representantesList: RepresentantoConDetalles[] = [];
  avatarUrls: { [key: string]: SafeUrl } = {}; // Almacena las URLs de los avatares
  model: Representante = {
    id_usuario: '',
    despacho_razon_social: ''
  };
  loaded = false;
  error = '';
  representantesLoaded = false; // Controla la visibilidad del div de instituciones
  isLoading = true; // Controla la visibilidad del spinner

  // Propiedades para el modal de confirmación de eliminación
  showConfirmDeleteModal: boolean = false;
  institucionToDeleteId: string | null = null;
  disableNoAdmin: boolean = true;

  casoCerrado: boolean = true;

  altaArbitro: boolean = false; // Controla si se muestra la sección de alta de árbitro
  emailExiste: boolean = false; // Variable para marcar si el correo existe
  validatingEmail: boolean = false; // Indica si la validación está en curso

  partesOptions: Select2Data = [];
  partesDefaultSelected: string[] = [];
  caso: any;

  parte: Parte = {
    tipo_parte: '',
    cif: '',
    razon_social: '',
    direccion: '',
    codigo_postal: '',
    poblacion: '',
    provincia: '',
    nacionalidad: '',
    comentarios: '',
    impuesto_aplicable: '',
    porcentaje_imputable: ''
  };

  altaArbitroFormSubmitted: boolean = false;
  
  nuevoArbitro: Parte = {
    despacho_razon_social: '',
    estado: '',
    nombre: '',
    apellidos: '',
    email: '',
    enviar_email_validacion: undefined,
    enviar_email_asociacion: undefined
  };



  constructor(
    private representantesService: RepresentantesPartesService,
    private usuarioService: UsuarioService,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private partesService: PartesService,
    private authService: AuthenticationService,
    private casosService: CasosService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.authService.currentUser().subscribe(user => {
      this.loaded = true;
      if (user?.nivel_acceso) {

        // Si soy admin no deshabilito opciones
        if (user.nivel_acceso == "ADMIN") {
          this.disableNoAdmin = false;
          this.loadUsuarios(); // Representantes en el form
          this.loadRepresentantes();
          //this.loadParte();
        }
        else {
          this.loadRepresentantes();
          this.loaded = true;
        }
      }
    });
  }

  loadUsuarios(): void {
    this.usuarioService.getUsuarios('es_representante=true&activo=true').subscribe({
      next: (data) => {
        this.usuariosList = data;
        this.usuarios = this.usuariosList.map((user): Select2Option => ({
          value: user.id || '', // Ensure value is not undefined
          label: `${user.nombre} ${user.apellidos} - ${user.email} ${!user.validado ? '(No validado)' : ''}`
        }));
        this.loaded = true;
      },
      error: (error) => {
        console.error('Error loading usuarios:', error);
        this.error = error;
        this.loaded = false;
      }
    });
  }

  loadRepresentantes(): void {
    const id_expediente = this.route.snapshot.paramMap.get('id');
    if (id_expediente) {
      this.casosService.getCaso(id_expediente).subscribe({
        next: (casoData) => {
          this.caso = casoData; // Hago una copia del caso
          this.casoCerrado = this.isCaseClosed();
          this.updatePartesOptions(); // Actualizo las Partes          

          const representantesList: RepresentantoConDetalles[] = [];

          // Buscamos la parte correspondiente a `this.parteId`
          const parteSeleccionada = casoData.partes.find((parte: Parte) => parte.id === this.parteId);

          // Verificamos si `parteParticipantes` está definido antes de iterar
          if (parteSeleccionada && parteSeleccionada.parteParticipantes && Array.isArray(parteSeleccionada.parteParticipantes)) {
            parteSeleccionada.parteParticipantes.forEach((participanteWrapper: any) => {
              const representante = participanteWrapper.participante;

              // Solo consideramos participantes de tipo 'REPRESENTANTE'
              if (representante.tipo === 'REPRESENTANTE') {
                const representanteConDetalles: RepresentantoConDetalles = {
                  ...representante,
                  nombre: representante.usuario?.nombre,
                  apellidos: representante.usuario?.apellidos,
                  despacho: representante.despacho
                };

                representantesList.push(representanteConDetalles);
              }
            });
          }

          // Asignamos la lista de representantes
          this.representantesList = representantesList;

          if (this.representantesList.length === 0) {
            this.representantesLoaded = true;
            this.isLoading = false;
            return;
          }

          // Cargamos los avatares de los representantes
          let avatarLoadCount = 0;
          this.representantesList.forEach((representante) => {
            if (representante.id_usuario) {
              this.usuarioService.getAvatar(representante.id_usuario).subscribe(avatarBlob => {
                if (avatarBlob) {
                  const blobUrl = URL.createObjectURL(avatarBlob);
                  // Verificamos que id_usuario está definido antes de usarlo como índice
                  if (representante.id_usuario) {
                    this.avatarUrls[representante.id_usuario] = this.sanitizer.bypassSecurityTrustUrl(blobUrl);
                  }
                }
                avatarLoadCount++;
                if (avatarLoadCount === this.representantesList.length) {
                  this.representantesLoaded = true;
                  this.isLoading = false;
                }
              });
            } else {
              avatarLoadCount++;
              if (avatarLoadCount === this.representantesList.length) {
                this.representantesLoaded = true;
                this.isLoading = false;
              }
            }
          });
        },
        error: (error) => {
          console.error('Error loading representantes:', error);
          this.error = error;
          this.isLoading = false;
        }
      });
    }
  }


  updatePartesOptions(): void {
    if (this.caso && this.parteId) {
      const parteSeleccionada = this.caso.partes.find((parte: any) => parte.id === this.parteId);
      if (parteSeleccionada) {
        const tipoParte = parteSeleccionada.tipo_parte;
  
        this.partesOptions = this.caso.partes
          .filter((parte: any) => parte.tipo_parte === tipoParte)
          .map((parte: any) => ({
            value: parte.id,
            label: parte.razon_social,
          }));

          // Marca por defecto la parte actual en el modelo
          this.partesDefaultSelected = [this.parteId]
      }
    }
  }



  loadParte() {
    this.partesService.getParte(this.parteId!).subscribe({
      next: (data) => {
        //console.log("getParte",data)
        this.parte = data;
        this.loaded = true;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading parte:', error);
        this.error = error;
        this.loaded = false;
        this.isLoading = false;
      }
    });
  }

  onSubmit(form: NgForm): void {
    if (this.parteId) {
      const id_expediente = this.route.snapshot.paramMap.get('id');
      if (id_expediente) {
        const newRepresentante: Representante = {
          id_expediente: id_expediente,
          id_usuario: form.value.id_usuario,
          despacho_razon_social: form.value.despacho_razon_social,
          tipo: "REPRESENTANTE",
          //fecha_designacion: new Date().toISOString().split('T')[0], // Asignar la fecha actual
          id_partes_seleccionadas: form.value.id_partes_seleccionadas,
          enviar_email_asociacion: form.value.enviar_email_asociacion === 'true'
        };

        //console.log("form.value->", form.value)

        this.isLoading = true; // Show spinner on submit
        //console.log("newRepresentante",newRepresentante)
        this.representantesService.newRepresentante(newRepresentante).subscribe({
          next: () => {
            //console.log("newRepresentante",newRepresentante)
            this.model = { id_usuario: '', despacho_razon_social: '', enviar_email_asociacion: undefined }; // Reset form model
            this.loadRepresentantes(); // Refresh the instituciones list
            //form.resetForm(); // Reset form validations
            this.refreshCase.emit();
          },
          error: (error) => {
            console.error('Error updating representante:', error);
            this.error = error;
            this.isLoading = false;
          }
        });
      }
    }
  }

  onRegistrarArbitro(form: NgForm): void {

    // Verificar si el email está siendo validado actualmente
    if (this.validatingEmail) {
      return; // Evitar que se registre mientras se valida
    }

    const email = form.value.email?.trim();
    if (email) {
      this.validatingEmail = true; // Comenzar validación del email

      this.representantesService.checkEmail(email).subscribe({
        next: (response) => {
          this.emailExiste = response; // Actualizar si el correo existe
          this.validatingEmail = false; // Validación finalizada

          if (this.emailExiste) {
            // Si el correo existe, no permitir continuar
            return;
          }

          // Proceder con el registro si el correo no existe
          this.registrarArbitro(form);
        },
        error: () => {
          this.emailExiste = false;
          this.validatingEmail = false;
        }
      });
    } else {
      this.emailExiste = true; // Email no válido o vacío
      return; // No proceder si no hay un correo válido
    }
  }

  private registrarArbitro(form: NgForm): void {
    if (this.parteId) {
      const id_expediente = this.route.snapshot.paramMap.get('id');
      if (id_expediente) {
        const newRepresentante: Representante = {
          id_expediente: id_expediente,
          id_usuario: form.value.id_usuario,
          despacho_razon_social: form.value.despacho_razon_social,
          tipo: "REPRESENTANTE",
          //fecha_designacion: new Date().toISOString().split('T')[0], // Asignar la fecha actual
          id_partes_seleccionadas: form.value.id_partes_seleccionadas,
          nombre: form.value.nombre,
          apellidos: form.value.apellidos,
          email: form.value.email,
          enviar_email_validacion: form.value.enviar_email_validacion === 'true',
          enviar_email_asociacion: form.value.enviar_email_asociacion === 'true'
        };

        this.isLoading = true; // Mostrar spinner al enviar
        this.representantesService.newRepresentante(newRepresentante).subscribe({
          next: () => {
            this.nuevoArbitro = {
              id_usuario: '', estado: 'ACTIVO', nombre: '', apellidos: '', email: '', enviar_email_validacion: undefined, enviar_email_asociacion: undefined, despacho_razon_social: ''
            }; // Reiniciar modelo del formulario            
            this.altaArbitro = false;
            this.loadUsuarios();
            this.loadRepresentantes(); // Refrescar la lista de tribunales
            form.resetForm(); // Reiniciar validaciones del formulario
            this.refreshCase.emit();
          },
          error: (error) => {
            this.error = error;
            this.isLoading = false;
          }
        });
      }
    }
  }

  toggleAltaArbitro(): void {
    this.nuevoArbitro = { estado: '', nombre: '', apellidos: '', email: '', tipo: '', fecha_designacion: undefined, arbitro_rol: '', arbitro_sistema_designacion: '', enviar_email_validacion: undefined, enviar_email_asociacion: undefined, despacho_razon_social: '' }; // Resetear modelo de alta
    this.altaArbitroFormSubmitted = false;
  }

  deleteInstitucion(id: string | undefined): void {
    if (id) {
      this.isLoading = true; // Show spinner on delete
      this.representantesService.deleteRepresentante(id).subscribe({
        next: () => {
          this.loadRepresentantes(); // Refresh the instituciones list
          this.refreshCase.emit();
        },
        error: (error) => {
          console.error('Error deleting institucion:', error);
          this.error = error;
          this.isLoading = false;
        }
      });
    }
  }

  // Método para abrir el modal
  openDeleteModal(id: string): void {
    this.institucionToDeleteId = id;
    this.showConfirmDeleteModal = true;
  }

  // Método para cerrar el modal
  closeDeleteModal(): void {
    this.showConfirmDeleteModal = false;
    this.institucionToDeleteId = null;
  }

  // Método para confirmar el borrado
  confirmDelete(): void {
    if (this.institucionToDeleteId) {
      this.deleteInstitucion(this.institucionToDeleteId);
    }
    this.closeDeleteModal();
  }

  onSwitchChange(id: string | undefined): void {
    const switchElement = document.getElementById(`switch_${id}`) as HTMLInputElement;
    if (switchElement) {
      const isChecked = switchElement.checked; // Estado del switch

      // Encuentra el tribunal correspondiente en la lista
      const institucionToUpdate = this.representantesList.find(tribunal => tribunal.id === id);
      if (institucionToUpdate) {
        // Actualiza el campo enviar_email_subida_archivo
        institucionToUpdate.enviar_email_subida_archivo = isChecked;

        // Crear el objeto para la actualización
        const institucionUpdateData: Parte = {
          id_usuario: institucionToUpdate.id_usuario,
          enviar_email_subida_archivo: isChecked // Nuevo valor del switch
        };

        // Llamar al servicio para actualizar en la base de datos
        if (id) {
          this.representantesService.updateRepresentante(id, institucionUpdateData).subscribe({
            next: () => {
              //console.log(`Tribunal con ID ${id} actualizado con éxito. Estado enviar_email_subida_archivo: ${isChecked}`);
              // Puedes emitir eventos o recargar los datos si es necesario
              //this.refreshCase.emit();
            },
            error: (error) => {
              //console.error('Error updating tribunal:', error);
              this.error = error;
              this.loadRepresentantes();
            }
          });
        }
      } else {
        console.error(`No se encontró el tribunal con ID ${id} en la lista.`);
      }
    } else {
      console.error(`No se encontró el switch con ID: switch_${id}`);
    }
  }

  onEmailBlur(email: string): void {
    if (email && email.trim() !== '') {
      this.validatingEmail = true; // Indica que la validación está en curso
      this.representantesService.checkEmail(email).subscribe({
        next: (response) => {
          this.emailExiste = response; // Actualiza si el correo existe
          this.validatingEmail = false; // Finaliza la validación
        },
        error: () => {
          this.emailExiste = false; // En caso de error, asumir que no existe
          this.validatingEmail = false; // Finaliza la validación
        }
      });
    } else {
      this.emailExiste = false; // Reinicia el estado si el email está vacío
      this.validatingEmail = false; // No está validando
    }
  }

  isCaseClosed(): boolean {
    const estadosCerrados = ['CERRADO_LAUDO', 'CERRADO_ACUERDO', 'CERRADO_OTROS', 'CERRADO_REENVIO'];
    return estadosCerrados.includes(this.caso.Estado ?? '');
  }

  onSwitchChangeHitos(id: string | undefined): void {
    const switchElement = document.getElementById(`switchHito_${id}`) as HTMLInputElement;
    if (switchElement && id) {
      const isChecked = switchElement.checked; // Estado del switch
      // Encuentra el tribunal correspondiente en la lista
      const representanteToUpdate = this.representantesList.find(representante => representante.id === id);
      if (representanteToUpdate) {
        // Actualiza el campo enviar_email_hito
        representanteToUpdate['enviar_email_hito'] = isChecked;
        // Crear el objeto para la actualización
        const representanteUpdateData: Representante = {
          id_usuario: representanteToUpdate.id_usuario,
          enviar_email_hito: isChecked // Nuevo valor del switch
        };
        // Llamar al servicio para actualizar en la base de datos
        this.representantesService.updateRepresentante(id, representanteUpdateData).subscribe({
          next: () => {
            //console.log(`Tribunal con ID ${id} actualizado con éxito. Estado enviar_email_hito: ${isChecked}`);
            // Puedes emitir eventos o recargar los datos si es necesario
            //this.refreshCase.emit();
          },
          error: (error) => {
            //console.error('Error updating tribunal:', error);
            this.error = error;
            this.loadRepresentantes();
          }
        });
      } else {
        console.error(`No se encontró el representante con ID ${id} en la lista.`);
      }
    } else {
      console.error(`No se encontró el switch con ID: switchHito_${id}`);
    }
  }

}
